import React from 'react';
import { cn } from '@/lib/utils';
import { ProgressBarStyle } from '@/store/videoFeatures';

interface EmbeddedProgressTrackProps {
  currentTime: number;
  duration: number;
  onSeek: (e: React.MouseEvent<HTMLDivElement>) => void;
  progressBarStyle?: ProgressBarStyle;
  color?: string;
}

export const EmbeddedProgressTrack: React.FC<EmbeddedProgressTrackProps> = React.memo(({
  currentTime,
  duration,
  onSeek,
  progressBarStyle,
  color = '#FFFFFF'
}) => {
  if (!duration || duration === 0) {
    return null;
  }
  const progressPercent = (currentTime / duration) * 100 || 0;

  return (
    <div
      key="embedded-progress-track"
      className={cn(
        "flex-1 h-1 bg-white/30 rounded-full cursor-pointer mx-3 min-w-0",
        "hover:h-1.5 transition-all duration-200"
      )}
      data-storyboard-target=""
      onClick={onSeek}
    >
      <div 
        className="h-full rounded-full transition-all duration-200"
        style={{ 
          width: `${progressPercent}%`,
          ...(progressBarStyle?.useGradient ? {
            background: `linear-gradient(90deg, ${progressBarStyle.gradientFrom} 0%, ${progressBarStyle.gradientTo} 100%)`
          } : {
            backgroundColor: color
          })
        }}
      />
    </div>
  );
});